module.exports = __webpack_public_path__ + "img/btnRight.e6088583.svg";